exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".f-example-tabs{padding-bottom:36px;margin-top:24px}.f-example-tabs ul.user-list-wrap{margin:0}.f-example-tabs ul.user-list-wrap li{display:flex;height:72px}.f-example-tabs ul.user-list-wrap li header{width:36px;height:36px;margin:18px;border-radius:50%;background:no-repeat 50%;background-size:cover}.f-example-tabs ul.user-list-wrap li section{position:relative;box-sizing:border-box;width:calc(100% - 72px);padding-right:16px;border-bottom:1px solid #f0f0f0;font-size:14px;color:rgba(0,0,0,.54)}.f-example-tabs ul.user-list-wrap li section .title{margin-top:14px;font-size:18px;color:rgba(0,0,0,.871)}.f-example-tabs ul.user-list-wrap li section .time{position:absolute;top:14px;right:10px}.f-example-tabs ul.user-list-wrap li section p{margin:4px 0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/containers/example/tabs.css
 ** module id = 566
 ** module chunks = 0
 **/